import * as React from 'react';
import {Box, Card, CardContent, Chip, Divider, Stack, Typography} from '@mui/material';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {useTranslation} from 'react-i18next';
import type {BranchStatusRow} from '../../../hooks/useDashboard';
import {evidenceChip} from '../branchStatusHelpers';

interface BranchStatusTableMobileProps {
    readonly rows: BranchStatusRow[];
}

export default function BranchStatusTableMobile({rows}: Readonly<BranchStatusTableMobileProps>): React.ReactElement {
    const {t} = useTranslation();

    return (
        <Stack spacing={2}>
            {rows.map((row) => (
                <Card
                    key={row.branchId}
                    variant="outlined"
                    onClick={row.onView}
                    sx={{
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        '&:active': {transform: 'scale(0.98)'},
                        '&:hover': {boxShadow: 2},
                    }}
                >
                    <CardContent>
                        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                            <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                <LocationOnOutlinedIcon fontSize="small" color="action"/>
                                <Typography variant="subtitle1" fontWeight={600}>{row.branchName}</Typography>
                            </Box>
                            {evidenceChip(row, t)}
                        </Box>
                        <Divider sx={{my: 1.5}}/>
                        <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                            <Typography variant="caption" sx={{color: 'text.secondary'}}>
                                {t('dashboard.branchStatus.header.employees')}
                            </Typography>
                            <Typography variant="caption" fontWeight={600}>{row.employeeCount}</Typography>
                        </Box>
                        <Box sx={{display: 'flex', justifyContent: 'flex-end', mt: 1}}>
                            <Chip
                                label={t('common.actions.view')}
                                size="small"
                                variant="outlined"
                                color="secondary"
                                icon={<ArrowForwardIcon/>}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    row.onView();
                                }}
                            />
                        </Box>
                    </CardContent>
                </Card>
            ))}
        </Stack>
    );
}
